import React from "react";
import { Link } from "react-router-dom";
import StorageService from "../utils/storage.service";
import axiosService from "../utils/axios.service";
import { Dropdown } from 'react-bootstrap';
import { NotificationContainer, } from "react-notifications";
import "../scss/header.scss";
import StoreHeader from "./stores/StoreHeader";
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
// import { ModalConfirmDaily } from './ModalConfirmDaily';
import socketIOClient from "socket.io-client";

const menuData = [
    { label: "Thu ngân", url: "/pos", icon: "fas fa-calculator", except: [2,4] },
    { label: "Khách hàng", url: "/customer", icon: "fas fa-female", except: [2,4] },
    {
        label: "Báo cáo",
        icon: "fas fa-chart-line",
        number: 5,
        submenu: [
            { 
                label: "Doanh thu",
                role: [1,4,8],
                submenu: [
                    { label: "Danh sách hóa đơn", url: "/orders", include: [1,4] },
                    { label: "Doanh số theo ngày", url: "/report/daily", include: [1,4] },
                    { label: "Doanh số theo chi nhánh", url: "/report/locations", include: [1,4,8] },
                    { label: "Tiền thu từng dịch vụ", url: "/report/service-detail", include: [1,4] },
                    { label: "Doanh thu chưa thực hiện", url: "/report/service-chua-thuc-hien", include: [1,4]},
                    { label: "Doanh thu Head Office", url: "/report/head-office", include: [1,4]},
                ],
            },
            {
                label: "Nhân viên",
                role: [1,2,3,5,8],
                submenu: [
                    { label: "Báo cáo tổng quan Sale", url: "/report/online", include: [1,4,8] },
                    { label: "Báo cáo lễ tân", url: "/report/offline-lt", include: [1,4,8] },
                    { label: "Báo cáo tư vấn & phục vụ offline", url: "/report/offline-ktv-tvv", include: [1,4,8] },
                    { label: "Chi tiết Sale", url: "/report/detail/sale-ctm", include: [1,5,4,8] },
                    { label: "Chi tiết KTV", url: "/report/detail/ktv-tvv", include: [1,2,4,3,8] },
                    { label: "Rating", url: "/report/rating", include: [1] }
                ],
            },
            {
                label: "Kinh doanh",
                role: [1,4,8],
                submenu: [
                    { label: "Vận hành cơ sở", url: "/report/operate-booking", include: [1,4] },
                    { label: "Kinh doanh cơ sở", url: "/report/business", include: [1,4] },
                    { label: "Khách hàng liệu trình", url: "/report/customer-course", include: [1,4] },
                    { label: "Khách hàng mới", url: "/report/customer-new", include: [1,4] },
                    { label: "Upsale / Mua thêm", url: "/report/upsale", include: [1,4] },
                    { label: "Tiền thu dự kiến", url: "/report/expected-cash", include: [1,4] },
                    { label: "Thu nợ", url: "/report/debt-collection", include: [1,4] },
                    { label: "Hành vi mua hàng", url: "/report/purchase-behavior", include: [1,4] },
                    { label: "Tư vấn cơ sở theo ngày", url: "/report/ktv-tv-details", include: [1,4] },
                    { label: "Chi tiết từng KTV", url: "/report/ktv-tvv-detail", include: [1,4,8] },
                    { label: "Doanh thu dự kiến", url: "/report/total-price-booking", include: [1,4] },
                    { label: "Thi đua", url: "/report/emulation", include: [1,4,8] },
                    { label: "Hiệu quả promotion", url: "/report/promotion", include: [1,4] },
                    { label: "Chi tiết promotion", url: "/report/detail-promotion", include: [1,4] }
                ],
            },
            {
                label: "Nhượng quyền",
                role: [1,4],
                submenu: [
                    { label: "Phục vụ", url: "/report/service-do-housework", include: [1,4]},
                    { label: "Dòng tiền", url: "/report/customer-paid-store", include: [1,4]},
                    { label: "Theo dõi BHVV", url: "/report/bhvv-flow", include: [1,4]},
                    { label: "Dịch vụ nâng cấp", url: "/report/hopper", include: [1,4] },
                ],
            },
            {
                label: "Tam trụ",
                role: [1],
                submenu: [
                    { label: "Độc lập", url: "/report/independence", include: [1]},
                    { label: "Tự do", url: "/report/freedom", include: [1]},
                    { label: "Hạnh phúc", url: "/report/happiness", include: [1]},
                ],
            },
        ],
    },
    { label: "Lấy voucher", url: "/create-voucher-lv3", icon: "fas fa-tag", except: [2] },
    { label: "QR Code", url: "/report/qr-code", icon: "fas fa-qrcode", except: [2] },
    { label: "Thẻ khách hàng", url: "/report/count/package-booking", icon: "fas fa-sd-card" },
];

const toggleSubMenu = (e) => {
    e.stopPropagation();
    let submenu = e.target.querySelector("[class ~= 'child-menu']");
    let parent = e.target

    if (e.target.nodeName === "I" || e.target.nodeName === "LABEL") {
        submenu = e.target.offsetParent.querySelector("[class ~= 'child-menu']");
        parent = e.target.offsetParent;
    } 

    if (!submenu) return;

    if (submenu.style.display === "none" || !submenu.style.display) {
      submenu.style.display = "block";
      parent.classList.add("active");
    } else {
      submenu.style.display = "none";
      parent.classList.remove("active");
    }
};

const renderSubMenuColumn = (subMenu, number, role) => {
    if (role == 4) {
        number = 2
    }
    return (
        <div className="child-menu">
            <div className="row">
                {subMenu.map((subItem, index) => (
                     subItem?.role ?
                        subItem.role.includes(role) &&
                        <div key={index} onClick={toggleSubMenu} className={`column`} style={{flex: "0 0 calc(100%/"+ number +")", maxWidth: "calc(100%/"+ number +")"}}>
                        <div className="border-bottom"><span className="dropText">{subItem.label}</span></div>
                            <div className="sub-menu-list">
                                {subItem.submenu.map((subMenuItem, subMenuIndex) => (
                                    subMenuItem?.except ?
                                        !subMenuItem.except.includes(role) &&
                                            <div key={subMenuIndex} className="item-sub-menu">
                                                <Link to={{ pathname: subMenuItem?.url}}>
                                                    {subMenuItem.label}
                                                </Link>
                                            </div>

                                    : subMenuItem?.include ?
                                        subMenuItem.include.includes(role) &&
                                            <div key={subMenuIndex} className="item-sub-menu">
                                                <Link to={{ pathname: subMenuItem?.url}}>
                                                    {subMenuItem.label}
                                                </Link>
                                            </div>
                                    :
                                        <div key={subMenuIndex} className="item-sub-menu">
                                            <Link to={{ pathname: subMenuItem?.url}}>
                                                {subMenuItem.label}
                                            </Link>
                                        </div>
                                ))}
                            </div>
                    </div>
                     : null
                ))}
            </div>

        </div>
    );
};
class Header extends React.Component {
    constructor() {
        super();
        this.state = {
            stores: [],
            userAdmin: JSON.parse(localStorage.getItem("user_info")),
            checkMobile: window.innerWidth <= 768,
            statusMenu: false,
            childBaoCao: false,
            daily: false
        };

        this.resize = this.resize.bind(this);
        this.socket = socketIOClient(process.env.REACT_APP_API_SOCKET, {
            transports: ['websocket'],
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000
        });
    }

    resize = () => {
        const currentHideNav = window.innerWidth <= 768;

        if (currentHideNav !== this.state.checkMobile) {
            this.setState({checkMobile: currentHideNav})}
    };

    logOut() {
        StorageService.delete("access_token");
        StorageService.delete("user_info");
        window.location.replace("/");
    }
    getDataStores() {
        const savedId = Number(StorageService.getItem("currentStore"))
        const applyStores = (stores) => {
            const list = Array.isArray(stores) ? stores : []
            const match = list.find((item) => Number(item.id) === savedId)
            if (match) {
                if (match.name_store) StorageService.set("currentNameStore", match.name_store)
                this.setState({ stores: list })
                return
            }
            if (savedId) {
                const saved = {
                    id: savedId,
                    name_store: StorageService.getItem("currentNameStore") || "",
                }
                this.setState({ stores: [saved, ...list] })
                return
            }
            if (list[0]) {
                StorageService.set("currentStore", list[0].id)
                StorageService.set("currentNameStore", list[0].name_store || "")
            }
            this.setState({ stores: list })
        }

        const currentUrl = window.location.pathname
        const user = this.state.userAdmin
        const useAssigned = user && user.stores && user.stores.length > 0 && (user.role == 4 || (user.role == 3 && currentUrl.includes("report")))
        if (useAssigned) {
            applyStores(user.stores)
            return
        }

        axiosService("api/stores", "GET", {}, this.props.token)
            .then((res) => {
                const response = res.data
                if (response.success && response.data) applyStores(response.data)
            }).catch((error) => console.log(error));
    }

    listenSocket = () => {
        this.socket.off("account_locked");
        this.socket.on("account_locked", (data) => {
            this.logOut();
        });
    };

    componentDidMount() {
        window.addEventListener("resize", this.resize);

        this.resize();
        this.getDataStores();

        const user = JSON.parse(localStorage.getItem("user_info"));

        const joinUserRoom = () => { if (user?.id) this.socket.emit("join-user", Number(user.id)) };

        this.socket.on("connect", joinUserRoom);

        if (this.socket.connected) joinUserRoom();
        
        this.listenSocket();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);

        this.socket.off("connect");
        this.socket.off("account_locked");
    }

    showDaily = ()=> {
        this.setState({
            daily : !this.state.daily
        });
    }

    render() {

        return (
            <React.Fragment>
                <div className="header">
                    <div className="header-top">
                        <div className="header-left">
                            {this.props.type !== "crm" ?
                                <>  
                                    {this.state.checkMobile ? 
                                        <div className="icon-menu" onClick={() => this.setState({ statusMenu: !this.state.statusMenu })}>
                                            <i className="fas fa-bars"></i>
                                        </div>
                                    :null}
                                    <div className="menu-item logo">
                                        <Link to={{ pathname: this.state.userAdmin?.role != 2 ? "/dashboard" : "/booking" }}>
                                            <img src="/images/header/logo3.png" alt="logo" />
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link to={{ pathname: "/booking" }}>
                                            <i className="snake-gift fa fa-fas fa-calendar-alt"></i>
                                            Lịch hẹn
                                        </Link>
                                    </div>
                                    <div className={`menu-list ${this.state.statusMenu ? "active" : ""}`}>
                                        {this.state.checkMobile ? 
                                            <div className="sidebar-head">
                                                <div className="tab_title">Menu</div>
                                            </div>
                                        :null}
                                        {menuData.map((item, index) => (
                                            item?.except ?
                                                !item.except.includes(this.state.userAdmin.role) &&
                                                    <div key={index} onClick={toggleSubMenu} className={`menu-item ${item.submenu ? "parent-item" : ""}`}>
                                                        {item.url && item?.url !== "#" ?
                                                            <Link to={{ pathname: item?.url}}>
                                                                {item?.icon && <i className={item.icon}></i>}
                                                                {item.label}
                                                            </Link>
                                                        : 
                                                            <label className="title-menu">
                                                                {item?.icon && <i className={item.icon}></i>}
                                                                {item.label}
                                                            </label>
                                                        }
                                                        {(item.submenu && item?.number && item?.number > 0) && renderSubMenuColumn(item.submenu, item?.number, this.state.userAdmin.role)}
                                                    </div>
                                            : item?.include ?
                                                item.include.includes(this.state.userAdmin.role) &&
                                                    <div key={index} onClick={toggleSubMenu} className={`menu-item ${item.submenu ? "parent-item" : ""}`}>
                                                        {item.url && item?.url !== "#" ?
                                                            <Link to={{ pathname: item?.url}}>
                                                                {item?.icon && <i className={item.icon}></i>}
                                                                {item.label}
                                                            </Link>
                                                        : 
                                                            <label className="title-menu">
                                                                {item?.icon && <i className={item.icon}></i>}
                                                                {item.label}
                                                            </label>
                                                        }
                                                        {(item.submenu && item?.number && item?.number > 0) && renderSubMenuColumn(item.submenu, item?.number, this.state.userAdmin.role)}
                                                    </div>
                                            :
                                                <div key={index} onClick={toggleSubMenu} className={`menu-item ${item.submenu ? "parent-item" : ""}`}>
                                                    {item.url && item?.url !== "#" ?
                                                        <Link to={{ pathname: item?.url}}>
                                                            {item?.icon && <i className={item.icon}></i>}
                                                            {item.label}
                                                        </Link>
                                                    : 
                                                        <label className="title-menu">
                                                            {item?.icon && <i className={item.icon}></i>}
                                                            {item.label}
                                                        </label>
                                                    }
                                                    {(item.submenu && item?.number && item?.number > 0) && renderSubMenuColumn(item.submenu, item?.number, this.state.userAdmin.role)}
                                                </div>
                                        ))}
                                    </div>
                                    {this.state.checkMobile ? 
                                        <>
                                            <div className={`overlay-menu ${this.state.statusMenu ? "active" : ""}`} onClick={() => this.setState({ statusMenu: !this.state.statusMenu })}></div>
                                            <div className={`close-button-menu ${this.state.statusMenu ? "active" : ""}`} onClick={() => this.setState({ statusMenu: !this.state.statusMenu })}>
                                                <svg role="presentation" viewBox="0 0 16 14">
                                                    <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fillRule="evenodd"></path>
                                                </svg>
                                            </div>
                                        </>
                                    :null}
                                </>
                            : null}
                        </div>
                        <div className="header-right">
                            {this.props.type != "crm" ? 
                                <>
                                    <StoreHeader stores={this.state.stores} checkMobile={this.state.checkMobile} />
                                    <div className="my-account">
                                        <Dropdown align={{ lg: 'end' }}>
                                            <Dropdown.Toggle className="button-drop" variant="#fff" style={{ "paddingBottom": "0px" }}>
                                                <Avatar size={30} icon={<UserOutlined />} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ left: "auto", right: "0px", position: "absolute" }}>
                                                <Dropdown.Item>
                                                    {this.state.userAdmin.name}
                                                </Dropdown.Item>
                                                <Dropdown.Item href={"/change-password"}>
                                                    <i className="fas fa-lock"></i><span className="ml-1 mt-2">Đổi mật khẩu</span>
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={() => { this.logOut() }}>
                                                    <i className="fa-solid fa-arrow-right-from-bracket"></i><span className="ml-1 mt-2">Đăng xuất</span>
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        {/* </div> */}
                                    </div>
                                </> 
                            : null}
                        </div>
                    </div>
                    <NotificationContainer />
                    {/* <ModalConfirmDaily
                        show={true}
                        showNewDaily={this.state.daily}
                        showDaily={this.showDaily}
                    /> */}
                </div>
                {this.state.userAdmin.role == 2 ? 
                    <div onClick={this.showDaily} className="show-data-target"> <i className="fas fa-cat snake-gift"></i></div>
                : null}
            </React.Fragment>
        );
    }
}
export default Header;
